import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EyeIcon, EyeOffIcon, TruckIcon } from 'lucide-react';
const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    password: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    // Basic validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match.');
      setLoading(false);
      return;
    }
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      navigate('/login');
      // In a real application, you would send the data to your backend here
    }, 1500);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-1231">
      <div className="max-w-md w-full space-y-8" data-id="element-1232">
        <div data-id="element-1233">
          <div className="mx-auto h-20 w-auto flex items-center justify-center" data-id="element-1234">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qrpHAAKgkN1H9JhJ8LpouX/ThePoint_LogoMark_RGB_Final.png" alt="The Point TMS" className="h-20 w-auto" data-id="element-1235" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-1236">
            Create your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1237">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-primary-700 hover:text-primary-800" data-id="element-1238">
              Sign in
            </Link>
          </p>
        </div>
        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-1239">
            <p className="text-sm text-red-700" data-id="element-1240">{error}</p>
          </div>}
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1241">
          <div className="rounded-md shadow-sm -space-y-px" data-id="element-1242">
            <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" data-id="element-1243">
              <div data-id="element-1244">
                <label htmlFor="firstName" className="sr-only" data-id="element-1245">
                  First name
                </label>
                <input id="firstName" name="firstName" type="text" required value={formData.firstName} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-tl-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="First name" data-id="element-1246" />
              </div>
              <div data-id="element-1247">
                <label htmlFor="lastName" className="sr-only" data-id="element-1248">
                  Last name
                </label>
                <input id="lastName" name="lastName" type="text" required value={formData.lastName} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-tr-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Last name" data-id="element-1249" />
              </div>
            </div>
            <div data-id="element-1250">
              <label htmlFor="email" className="sr-only" data-id="element-1251">
                Email address
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required value={formData.email} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Email address" data-id="element-1252" />
            </div>
            <div data-id="element-1253">
              <label htmlFor="companyName" className="sr-only" data-id="element-1254">
                Company Name
              </label>
              <input id="companyName" name="companyName" type="text" required value={formData.companyName} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Company Name" data-id="element-1255" />
            </div>
            <div className="relative" data-id="element-1256">
              <label htmlFor="password" className="sr-only" data-id="element-1257">
                Password
              </label>
              <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" required value={formData.password} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Password" data-id="element-1258" />
              <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-1259">
                {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-1260" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-1261" />}
              </button>
            </div>
            <div className="relative" data-id="element-1262">
              <label htmlFor="confirmPassword" className="sr-only" data-id="element-1263">
                Confirm Password
              </label>
              <input id="confirmPassword" name="confirmPassword" type={showConfirmPassword ? 'text' : 'password'} autoComplete="new-password" required value={formData.confirmPassword} onChange={handleChange} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Confirm password" data-id="element-1264" />
              <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-1265">
                {showConfirmPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-1266" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-1267" />}
              </button>
            </div>
          </div>
          <div data-id="element-1268">
            <button type="submit" disabled={loading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-primary-300" data-id="element-1269">
              {loading ? <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1270">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1271"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1272"></path>
                  </svg>
                  Creating account...
                </> : 'Sign up'}
            </button>
          </div>
          <div className="text-sm text-center" data-id="element-1273">
            <p className="text-gray-500" data-id="element-1274">
              By signing up, you agree to our{' '}
              <a href="#" className="font-medium text-primary-700 hover:text-primary-800" data-id="element-1275">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="#" className="font-medium text-primary-700 hover:text-primary-800" data-id="element-1276">
                Privacy Policy
              </a>
            </p>
          </div>
        </form>
      </div>
    </div>;
};
export default Register;